<template>
  <div class="container-lg clearfix px-2">
    <div v-if="hydrant" class="Box">
      <div class="Box-header">
        <h3 class="Box-title">
          {{ hydrant.name }}
          <span v-if="hydrantCheckCount > 0" class="ml-2 Counter Counter--gray"
            >{{ hydrantCheckCount }} checks</span
          >
        </h3>
      </div>
      <div class="Box-body">
        <p v-if="hydrantCheckCount === 0" class="text-emphasized">
          No checks recorded.
        </p>
        <ul v-if="hydrantCheckCount !== 0">
          <li
            v-for="hydrantCheck in hydrantChecks"
            v-bind:key="hydrantCheck.id"
            class="Box-row"
          >
            <strong>{{ formattedDate(hydrantCheck) }}</strong>
            at
            <strong>{{ formattedTime(hydrantCheck) }}</strong>
            in
            <strong>{{ apparatusName(hydrantCheck) }}</strong>
            <div class="text-small text-gray-light">
              {{ hydrantCheck.notes }}
            </div>
            <h4>PO: {{ pumpOperatorName(hydrantCheck) }}</h4>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "HydrantView",
  props: {
    hydrant_id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      pumpOperators: [],
      apparatus: []
    };
  },
  created() {
    this.$store.dispatch("getEverything");
  },
  computed: {
    hydrant() {
      return this.$store.state.hydrants.find(hydrant => {
        return hydrant.id === this.hydrant_id;
      });
    },
    hydrantChecks() {
      return this.$store.state.hydrantChecks
        .filter(hydrantCheck => {
          return hydrantCheck.hydrant_id === this.hydrant_id;
        })
        .sort((first, second) => {
          return first.created_at < second.created_at ? 1 : -1;
        });
    },
    hydrantCheckCount() {
      return this.hydrantChecks.length;
    }
  },
  methods: {
    pumpOperatorName(check) {
      const operator = this.$store.state.pumpOperators.find(pumpOperator => {
        return pumpOperator.id === check.pump_operator_id;
      });
      return operator.name;
    },
    formattedDate(check) {
      return moment(check.created_at)
        .tz(moment.tz.guess())
        .local()
        .format("MM/DD/YYYY");
    },
    formattedTime(check) {
      return moment
        .utc(check.created_at)
        .tz(moment.tz.guess())
        .local()
        .format("kk:mm");
    },
    apparatusName(check) {
      const vehicle = this.$store.state.apparatus.find(apparatus => {
        return apparatus.id === check.apparatus_id;
      });
      return vehicle.name;
    }
  }
};
</script>
